export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crypto ID:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Язык"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Доброе утро"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Добрый день"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Добрый вечер"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Доброй ночи"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выйти"])}
}